import { ComponentProps, FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from '@treams/treams-network';
import { Avatar, Button } from '@treams/treams-ui';

import { UserRow } from '../UserRow';

type Props = {
	avatar: ComponentProps<typeof Avatar> & {
		user: NonNullable<ComponentProps<typeof Avatar>['user']>;
	};
	subtitle: string;
	viewerIsUser?: boolean;
	onShare: () => void;
	onStopSharing: () => void;
	action?: 'share' | 'stopSharing';
};

export const ShareUser: FC<Props> = ({
	avatar: { user },
	subtitle,
	action,
	onShare,
	onStopSharing,
	viewerIsUser,
}) => {
	const { t } = useTranslation();

	const renderUserTitle = useCallback(
		(user: Pick<User, 'firstName' | 'lastName'>) => {
			if (viewerIsUser) {
				return t('sharing.user.you');
			}
			return `${user.firstName} ${user.lastName}`;
		},
		[t, viewerIsUser],
	);

	return (
		<UserRow user={user} renderUserTitle={renderUserTitle} subtitle={subtitle}>
			{action === 'share' && (
				<Button
					height={38}
					title={t('sharing.user.share.with', {
						firstName: user.firstName,
					})}
					onClick={onShare}
					type="secondary"
				/>
			)}
			{action === 'stopSharing' && (
				<Button
					height={38}
					title={t('sharing.user.stop.sharing')}
					onClick={onStopSharing}
					type="destructive"
				/>
			)}
		</UserRow>
	);
};
